import { RosterTableContext } from 'client/contexts'
import { useContext } from 'react'

/**
 * Provides access to values in the candidate search context.
 */
export const useRosterTable = () => {
    const rosterTableContext = useContext(RosterTableContext)

    if (!rosterTableContext) {
        throw new Error('useRosterTable must be used within <useRosterTable>')
    }

    return rosterTableContext
}
